import { ITranslationItems } from './language.types';

export const LABELS: ITranslationItems = {
  priceLabel: {
    nl: 'Prijs vanaf',
    en: 'Price from',
  },
  priceValue: {
    nl: 'Gratis',
    en: 'Free',
  },
  primaryLink: {
    nl: 'Lees meer',
    en: 'Read more',
  },
  secondaryLink: {
    nl: 'Meer informatie',
    en: 'More information',
  },
};

export default { LABELS };
